module.exports = __webpack_public_path__ + "img/wyfwx.7b95eb8b.jpg";